import { render, staticRenderFns } from "./ImageYoutube.vue?vue&type=template&id=7df415f4&scoped=true"
var script = {}
import style0 from "./ImageYoutube.vue?vue&type=style&index=0&id=7df415f4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df415f4",
  null
  
)

export default component.exports